import React from "react";
import { Fragment } from "react";
import {
  AppBar,
  Box,
  Button,
  Container,
  Grid,
  Paper,
  IconButton,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/material";
import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import ClientFilingMasterContext from "../../context/client-filing-master/ClientFilingMasterContext";
import AuthContext from "../../context/auth/AuthContext";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import usePermission from "../../usePermission";
import RollOverFilingsToolBox from "./RollOverFilingsToolBox"
import { styled } from "@mui/material/styles";
import RollOverFilingsHistory from './RollOverFilingsHistory'
import CustomDialog from "../common/CustomDialog";
import { useCommonDetailsContext } from "../../context/Common/common";
import { tokens } from "../../theme/tokens";

const theme = createTheme({
  typography: {
    subtitle1: {
      fontSize: 14,
      fontWeight: 100,
      fontStyle: "italic",
      fontFamily: "unset",
    },
  },
});

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

export default function RollOverFilings() {
  const { publishedBranding } = useCommonDetailsContext();
  const primaryColor =
    publishedBranding?.primaryColor || tokens.colors.connectedPurple;
  const API_BASE_URL = process.env.REACT_APP_TRKNW_API_BASE_URL;
  //TRACKNOW STATE VARIABLES
  const [filingMasterSuccess, setFilingMasterSuccess] = useState(false);
  const [filingMasterError, setFilingMasterError] = useState(false);
  const [clientFilingMasterSuccess, setClientFilingMasterSuccess] =
    useState(false);
  const [clientFilingMasterError, setclientFilingMasterError] = useState(false);
  const [filingMasterErr, setFilingMasterErr] = useState("");
  const [clientFilingMasterErr, setClientFilingMasterErr] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState<any>({});
  const [alertMessage, setAlertMessage] = React.useState("");
  const [showAlert, setShowAlert] = React.useState(false);
  const [activityHistory, setActivityHistory] = React.useState([]);
  const [showHistory, setShowHistory] = useState(false);

  //POSTAWARD STATE VARIABLES
  const [filingMasterSuccessPa, setFilingMasterSuccessPa] = useState(false);
  const [filingMasterErrorPa, setFilingMasterErrorPa] = useState(false);
  const [clientFilingMasterSuccessPa, setClientFilingMasterSuccessPa] =
    useState(false);
  const [clientFilingMasterErrorPa, setclientFilingMasterErrorPa] =
    useState(false);
  const [filingMasterErrPa, setFilingMasterErrPa] = useState("");
  const [clientFilingMasterErrPa, setClientFilingMasterErrPa] = useState("");
  //const [isLoading, setIsLoading] = useState(false);
  const [statusPa, setStatusPa] = useState<any>({});
  const [alertMessagePa, setAlertMessagePa] = React.useState("");
  const [showAlertPa, setShowAlertPa] = React.useState(false);

  const clientFilingMasterContext = useContext(ClientFilingMasterContext);
  const { fetchConfigurations, updateReminderConfiguration } =
    clientFilingMasterContext;

  const authContext = React.useContext(AuthContext);
  const { roleType, authUser } = authContext;
  console.log("roleTypeCheck", roleType);

  //TRACKNOW HANDLE
  const clientFilingRollOver = async () => {
    try {
      setIsLoading(true);
      let clientFilingInc = null;
      const clientFiling = await axios.get(
        `${API_BASE_URL}/Customer/GetConfigValue?ConfigItem=CurrentYear`
      );
      if (clientFiling) {
        clientFilingInc = clientFiling.data + 1;
        if (clientFilingInc) {
          const res = await axios.put(
            `${API_BASE_URL}/Customer/CustomerFilingMasterRollover`
          );

          console.log("clientFilingRollOver res", res.data.status);
          if (res.data.status === "Success") {
            // Request URL for creating history while initiating the Rollover:
            const resHis = await axios.post(
              `${API_BASE_URL}/Application/CreateRolloverActivity`, {
              userID: authUser?.userId + "",
              rolloverAction: "Tracknow Client Filing Master Rollover",
            }
            );
            setClientFilingMasterSuccess(true);
            checkStatus("clientFilingRollOverStatus");
            rollOverStatus();
          } else if (res.data.status === "Failure") {
            setClientFilingMasterErr(res.data.errorMessage);
            setclientFilingMasterError(true);
          }
        }
      }
    } catch (filingMasterError) {
      console.log("@@Error:", filingMasterError);
    } finally {
      setIsLoading(false);
      rollOverStatus();
    }
  };
  const filingMasterRollOver = async () => {
    try {
      setIsLoading(true);

      let masterFilingInc = null;

      const filingMaster = await axios.get(
        `${API_BASE_URL}/FilingMaster/GetConfigValue?ConfigItem=CurrentYear`
      );
      if (filingMaster) {
        masterFilingInc = filingMaster.data + 1;
        if (masterFilingInc) {
          const res = await axios.put(
            `${API_BASE_URL}/FilingMaster/FilingMasterRollover`
          );

          console.log("filingMasterRollOver res", res.data.status);

          if (res.data.status === "Success") {
            // Request URL for creating history while initiating the Rollover:
            const resHis = await axios.post(
              `${API_BASE_URL}/Application/CreateRolloverActivity`, {
              userID: authUser?.userId + "",
              rolloverAction: "Tracknow Filing Master Rollover",

            }
            );
            setFilingMasterSuccess(true);
            checkStatus("masterFilingRollOverStatus");
            rollOverStatus();
          } else if (res.data.status === "Failure") {
            setFilingMasterErr(res.data.errorMessage);
            setFilingMasterError(true);
          }
        }
      }
    } catch (filingMasterError) {
      console.log("@@Error:", filingMasterError);
    } finally {
      setIsLoading(false);
      rollOverStatus();
    }
  };

  //POSTAWARD HANDLE
  const clientFilingRollOverPa = async () => {
    try {
      setIsLoading(true);
      let clientFilingInc = null;
      const clientFiling = await axios.get(
        `${API_BASE_URL}/Customer/GetConfigValue?ConfigItem=CurrentYear`
      );
      if (clientFiling) {
        clientFilingInc = clientFiling.data + 1;
        if (clientFilingInc) {
          const res = await axios.put(
            `${API_BASE_URL}/Customer/PostAwardCustomerFilingMasterRollover`
          );

          console.log("clientFilingRollOverPa res", res.data.status);

          if (res.data.status === "Success") {
            // Request URL for creating history while initiating the Rollover:
            const resHis = await axios.post(
              `${API_BASE_URL}/Application/CreateRolloverActivity`, {
              userID: authUser?.userId + "",
              rolloverAction: "Postaward Client Filing Master Rollover",

            }
            );
            setClientFilingMasterSuccessPa(true);
            checkStatusPa("clientPostAwardRollOverStatus");
            rollOverStatusPa();
          } else if (res.data.status === "Failure") {
            setClientFilingMasterErrPa(res.data.errorMessage);
            setclientFilingMasterErrorPa(true);
          }
        }
      }
    } catch (filingMasterErrorPa) {
      console.log("@@Error:", filingMasterErrorPa);
    } finally {
      setIsLoading(false);
      rollOverStatusPa();
    }
  };
  const filingMasterRollOverPa = async () => {
    try {
      setIsLoading(true);

      let masterFilingInc = null;

      const filingMaster = await axios.get(
        `${API_BASE_URL}/FilingMaster/GetConfigValue?ConfigItem=CurrentYear`
      );
      if (filingMaster) {
        masterFilingInc = filingMaster.data + 1;
        if (masterFilingInc) {
          const res = await axios.put(
            `${API_BASE_URL}/FilingMaster/PostAwardFilingMasterRollover`
          );

          console.log("filingMasterRollOverPa res", res.data.status);

          if (res.data.status === "Success") {
            // Request URL for creating history while initiating the Rollover:
            const resHis = await axios.post(
              `${API_BASE_URL}/Application/CreateRolloverActivity`, {
              userID: authUser?.userId + "",
              rolloverAction: "Postaward Filing Master Rollover",
            }
            );
            setFilingMasterSuccessPa(true);
            checkStatusPa("postAwardRollOverStatus");
            rollOverStatusPa();
          } else if (res.data.status === "Failure") {
            setFilingMasterErrPa(res.data.errorMessage);
            setFilingMasterErrorPa(true);
          }
        }
      }
    } catch (filingMasterErrorPa) {
      console.log("@@Error:", filingMasterErrorPa);
    } finally {
      setIsLoading(false);
      rollOverStatusPa();
    }
  };
  const handleFilingMasterSuccessPa = () => {
    setFilingMasterSuccessPa(() => false);
  };
  const handleFilingMasterErrorPa = () => {
    setFilingMasterErrorPa(() => false);
  };
  const handleClientFilingMasterSuccessPa = () => {
    setClientFilingMasterSuccessPa(() => false);
  };
  const handleClentFilingMasterErrorPa = () => {
    setclientFilingMasterErrorPa(() => false);
  };

  const navigate = useNavigate();


  // const completeRollOver = async () => {
  //   if (fetchConfigurations && updateReminderConfiguration) {
  //     let config = await fetchConfigurations();
  //     console.log("completeRollOver", config);
  //     let currentYear = config.filter(
  //       (ele: any) => ele.configItem === "CurrentYear"
  //     );
  //     console.log("completeRollOver", currentYear);
  //     let newYear = parseInt(currentYear[0].configItemValue) + 1;
  //     let updateConfig = {
  //       ...currentYear[0],
  //       configItemValue: newYear + "",
  //       updateDate: new Date(Date.now()).toISOString(),
  //       updateUser: authUser?.userId + "",
  //     };
  //     console.log("completeRollOver payload", updateConfig);
  //     let res = await updateReminderConfiguration([updateConfig]);
  //     console.log("completeRollOver res", res);
  //     if (res) {
  //       setAlertMessage(`Rollover successfully completed`);
  //       setShowAlert(true);
  //       rollOverStatus();
  //     }
  //   }
  // };

  //TRACKNOW completeRollOver fUNC
  const completeRollOver = async () => {
    const res = await axios.put(`${API_BASE_URL}/Application/CompleteRollover`);
    // Request URL for creating history while initiating the Rollover:

    console.log("Complete-res", res, res.status);

    if (res) {
      const resHis = await axios.post(
        `${API_BASE_URL}/Application/CreateRolloverActivity`, {
        userID: authUser?.userId + "",
        rolloverAction: "Rollover Completed"
      }
      );
      setAlertMessage(`Rollover successfully completed`);
      setShowAlert(true);
      rollOverStatus();
      rollOverStatusPa();
    }
  };

  //POSTAWARD completeRollOver fUNC
  const completeRollOverPa = async () => {
    const res = await axios.put(`${API_BASE_URL}/Application/CompleteRollover`);
    console.log("Complete-res", res, res.status);

    if (res) {
      setAlertMessagePa(`Rollover successfully completed`);
      setShowAlertPa(true);
      rollOverStatusPa();
    }
  };

  //TRACKNOW CHECKSTATUS FUNC
  const checkStatus = (val: any) => {
    console.log("checkStatus", val);
    let statusTimeout = setTimeout(async () => {
      let res = await rollOverStatus();
      console.log("checkStatus", res);
      if (res[val] === "Completed") {
        clearTimeout(statusTimeout);
      } else {
        checkStatus(val);
      }
    }, 60000);
  };

  //POSTAWARD CHECKSTATUS FUNC
  const checkStatusPa = (val: any) => {
    console.log("checkStatus", val);
    let statusTimeout = setTimeout(async () => {
      let res = await rollOverStatusPa();
      console.log("checkStatus", res);
      if (res[val] === "Completed") {
        clearTimeout(statusTimeout);
      } else {
        checkStatusPa(val);
      }
    }, 60000);
  };

  //tracknow ROLLOVER STATUS FUNC
  const rollOverStatus = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/Application/RollOverStatus`);
      console.log("rollOverStatus res", res.data.data);
      let status = { ...res.data.data[0] };
      if (
        res.data.data[0].masterFilingRollOverStatus === "Open" &&
        res.data.data[0].clientFilingRollOverStatus === "Open"
      ) {
        status.masterBtn = true;
        status.masterBtnTitle = "Initiate Tracknow Filing Master Rollover";
        status.clientBtn = false;
        status.clientBtnTitle =
          "Initiate Tracknow Client Filing Master Rollover";
        status.completeBtn = false;
      } else if (
        res.data.data[0].masterFilingRollOverStatus === "In-Progress" &&
        res.data.data[0].clientFilingRollOverStatus === "Open"
      ) {
        status.masterBtn = true;
        status.masterBtnTitle = "Complete Tracknow Filing Master Rollover";
        status.clientBtn = false;
        status.clientBtnTitle =
          "Initiate Tracknow Client Filing Master Rollover";
        status.completeBtn = false;
      } else if (
        res.data.data[0].masterFilingRollOverStatus === "Completed" &&
        res.data.data[0].clientFilingRollOverStatus === "Open"
      ) {
        status.masterBtn = false;
        status.masterBtnTitle = "Completed Tracknow Filing Master Rollover";
        status.clientBtn = true;
        status.clientBtnTitle =
          "Initiate Tracknow Client Filing Master Rollover";
        status.completeBtn = false;
      } else if (
        res.data.data[0].masterFilingRollOverStatus === "Completed" &&
        res.data.data[0].clientFilingRollOverStatus === "In-Progress"
      ) {
        status.masterBtn = false;
        status.masterBtnTitle = "Completed Tracknow Filing Master Rollover";
        status.clientBtn = true;
        status.clientBtnTitle =
          "Complete Tracknow Client Filing Master Rollover";
        status.completeBtn = false;
      } else if (
        res.data.data[0].masterFilingRollOverStatus === "Completed" &&
        res.data.data[0].clientFilingRollOverStatus === "Completed"
      ) {
        status.masterBtn = false;
        status.masterBtnTitle = "Completed Tracknow Filing Master Rollover";
        status.clientBtn = false;
        status.clientBtnTitle =
          "Completed Tracknow Client Filing Master Rollover";
        status.completeBtn = true;
      }
      status.masterBtnVal = "TrackNowMasterFilingRollover"
      status.clientBtnVal = "TrackNowCustomerFilingRollover"
      setStatus(status);

      return status;
    } catch (error) {
      console.log("rollOverStatus Error:", error);
    }
  };

  //POSTAWARD ROLLOVER STATUS FUNC
  const rollOverStatusPa = async () => {
    console.log("@@Fetch rollOverStatus");
    try {
      const res = await axios.get(
        `${API_BASE_URL}/Application/PostAwardRollOverStatus`
      );
      console.log("rollOverStatus res", res.data.data);
      let status = { ...res.data.data[0] };
      if (
        res.data.data[0].postAwardRollOverStatus === "Open" &&
        res.data.data[0].clientPostAwardRollOverStatus === "Open"
      ) {
        status.masterBtn = true;
        status.masterBtnTitle = "Initiate Postaward Filing Master Rollover";
        status.clientBtn = false;
        status.clientBtnTitle =
          "Initiate Postaward Client Filing Master Rollover";
        status.completeBtn = false;
      } else if (
        res.data.data[0].postAwardRollOverStatus === "In-Progress" &&
        res.data.data[0].clientPostAwardRollOverStatus === "Open"
      ) {
        status.masterBtn = true;
        status.masterBtnTitle = "Complete Postaward Filing Master Rollover";
        status.clientBtn = false;
        status.clientBtnTitle =
          "Initiate Postaward Client Filing Master Rollover";
        status.completeBtn = false;
      } else if (
        res.data.data[0].postAwardRollOverStatus === "Completed" &&
        res.data.data[0].clientPostAwardRollOverStatus === "Open"
      ) {
        status.masterBtn = false;
        status.masterBtnTitle = "Completed Postaward Filing Master Rollover";
        status.clientBtn = true;
        status.clientBtnTitle =
          "Initiate Postaward Client Filing Master Rollover";
        status.completeBtn = false;
      } else if (
        res.data.data[0].postAwardRollOverStatus === "Completed" &&
        res.data.data[0].clientPostAwardRollOverStatus === "In-Progress"
      ) {
        status.masterBtn = false;
        status.masterBtnTitle = "Completed Postaward Filing Master Rollover";
        status.clientBtn = true;
        status.clientBtnTitle =
          "Complete Postaward Client Filing Master Rollover";
        status.completeBtn = false;
      } else if (
        res.data.data[0].postAwardRollOverStatus === "Completed" &&
        res.data.data[0].clientPostAwardRollOverStatus === "Completed"
      ) {
        status.masterBtn = false;
        status.masterBtnTitle = "Completed Postaward Filing Master Rollover";
        status.clientBtn = false;
        status.clientBtnTitle =
          "Completed Postaward Client Filing Master Rollover";
        status.completeBtn = true;
      }
      status.masterBtnVal = "PostAwardMasterFilingRollover"
      status.clientBtnVal = "PostAwardCustomerFilingRollover"
      setStatusPa(status);
      console.log("status", status);

      return status;
    } catch (error) {
      console.log("@@rollOverStatus Error:", error);
    }
  };
  useEffect(() => {
    rollOverStatus();
    rollOverStatusPa();
  }, []);
  console.log("Statuscheck", status, "statusPaCheck", statusPa);

  const isAdmin = Array.isArray(roleType) ? roleType.includes("Admin") : false;
  const isAdminPostaward = Array.isArray(roleType)
    ? roleType.includes("Admin-PostAward")
    : false;

  console.log(
    "Permission-check",
    "ADMIN",
    isAdmin,
    "isAdminPostaward",
    isAdminPostaward
  );


  const displayHistory = async () => {
    console.log("displayHistory")

    try {
      // const history = await axios.get(
      //   `${API_BASE_URL}/Application/RollOversAuditlog?Status=${selectedRollOver}`
      // );
      const history = await axios.get(
        `${API_BASE_URL}/Application/GetRolloverActivity`
      );
      console.log("displayHistory", "history", history)
      setActivityHistory(() => history.data.data);
      setShowHistory(() => true);
    } catch (error) {
      console.log("@@Error:", error);
    }
  }

  const closeHistory = () => {
    // console.log("Toggling Show Filter", showHistory);
    setShowHistory(() => false);
  };


  return (
    <Fragment>
      <div>
        <CustomDialog
          header="Info"
          visible={filingMasterSuccess}
          onHide={() => setFilingMasterSuccess(false)}
          footer={null}
        >
          Tracknow Filing Master successfully rolled over to the next year
        </CustomDialog>
        <CustomDialog
          header="Info"
          visible={filingMasterError}
          onHide={() => setFilingMasterError(false)}
          footer={null}
        >
          {filingMasterErr}
        </CustomDialog>
        <CustomDialog
          header="Info"
          visible={clientFilingMasterSuccess}
          onHide={() => setClientFilingMasterSuccess(false)}
          footer={null}
        >
          Tracknow Client Filing Master successfully rolled over to the next year
        </CustomDialog>
        <CustomDialog
          header="Info"
          visible={clientFilingMasterError}
          onHide={() => setclientFilingMasterError(false)}
          footer={null}
        >
          {clientFilingMasterErr}
        </CustomDialog>
        <CustomDialog
          header="Info"
          visible={showAlert}
          onHide={() => setShowAlert(false)}
          footer={null}
        >
          <p className='m-0'>{alertMessage}</p>
        </CustomDialog>

        <CustomDialog
          header="Info"
          visible={filingMasterSuccessPa}
          onHide={() => setFilingMasterSuccessPa(false)}
          footer={null}
        >
          Postaward Filing Master successfully rolled over to the next year
        </CustomDialog>
        <CustomDialog
          header="Info"
          visible={filingMasterErrorPa}
          onHide={() => setFilingMasterErrorPa(false)}
          footer={null}
        >
          {filingMasterErrPa}
        </CustomDialog>
        <CustomDialog
          header="Info"
          visible={clientFilingMasterSuccessPa}
          onHide={() => setClientFilingMasterSuccessPa(false)}
          footer={null}
        >
          Postaward Client Filing Master successfully rolled over to the next year
        </CustomDialog>
        <CustomDialog
          header="Info"
          visible={clientFilingMasterErrorPa}
          onHide={() => setclientFilingMasterErrorPa(false)}
          footer={null}
        >
          {clientFilingMasterErrPa}
        </CustomDialog>
        <CustomDialog
          header="Info"
          visible={showAlertPa}
          onHide={() => setShowAlertPa(false)}
          footer={null}
        >
          <p className='m-0'>{alertMessagePa}</p>
        </CustomDialog>
      </div>

      <Grid container spacing={2} sx={{ height: "90vh", padding: "1rem" }}>
        <Grid item xs={11.3} sx={{ height: "100%" }}>
          <Stack direction="column" spacing={5} sx={{ height: "100%" }}>
            {isAdmin && (
              <Stack direction='column' spacing={2}>
                <Typography variant='h6' sx={{ color: 'white' }}>TrackNow Rollover Filings</Typography>
                <Stack direction='row' justifyContent='space-evenly'>
                  <Stack direction='column' alignItems='center' justifyContent='center'>
                    <div>
                      <Button
                        onClick={filingMasterRollOver}
                        disabled={!status.masterBtn}
                        sx={{
                          backgroundColor: primaryColor,
                          color: tokens.colors.white,
                          borderRadius: "50px",
                          textTransform: "none",
                          padding: "10px 24px",
                          "&:hover": { backgroundColor: primaryColor },
                          "&:disabled": { backgroundColor: "#e0e0e0", color: "#9e9e9e" }
                        }}
                      >
                        {status.masterBtnTitle}
                      </Button>
                    </div>
                    {status.masterBtn && (
                      <ThemeProvider theme={theme}>
                        <Typography variant='subtitle1' sx={{ color: 'white' }}>
                          {" "}
                          Rollover year:{status.rollOverYear}
                        </Typography>
                      </ThemeProvider>
                    )}
                  </Stack>

                  <Stack direction='column' alignItems='center' justifyContent='center'>
                    <div>
                      <Button
                        onClick={clientFilingRollOver}
                        disabled={!status.clientBtn}
                        sx={{
                          backgroundColor: primaryColor,
                          color: tokens.colors.white,
                          borderRadius: "50px",
                          textTransform: "none",
                          padding: "10px 24px",
                          "&:hover": { backgroundColor: primaryColor },
                          "&:disabled": { backgroundColor: "#e0e0e0", color: "#9e9e9e" }
                        }}
                      >
                        {status.clientBtnTitle}
                      </Button>
                    </div>
                    {status.clientBtn && (
                      <ThemeProvider theme={theme}>
                        <Typography variant='subtitle1' sx={{ color: 'white' }}>
                          {" "}
                          Rollover year:{status.rollOverYear}
                        </Typography>
                      </ThemeProvider>
                    )}
                  </Stack>
                </Stack>
              </Stack>
            )}

            {isAdminPostaward && (
              <Stack direction='column' spacing={2}>
                <Typography variant='h6' sx={{ color: 'white' }}>PostAward Rollover Filings</Typography>
                <Stack direction='row' justifyContent='space-evenly'>
                  <Stack direction='column' alignItems='center' justifyContent='center'>
                    <div>
                      <Button
                        onClick={filingMasterRollOverPa}
                        disabled={!statusPa.masterBtn}
                        sx={{
                          backgroundColor: primaryColor,
                          color: tokens.colors.white,
                          borderRadius: "50px",
                          textTransform: "none",
                          padding: "10px 24px",
                          "&:hover": { backgroundColor: primaryColor },
                          "&:disabled": { backgroundColor: "#e0e0e0", color: "#9e9e9e" }
                        }}
                      >
                        {statusPa.masterBtnTitle}
                      </Button>
                    </div>
                    {statusPa.masterBtn && (
                      <ThemeProvider theme={theme}>
                        <Typography variant='subtitle1' sx={{ color: 'white' }}>
                          {" "}
                          Rollover year:{statusPa.rollOverYear}
                        </Typography>
                      </ThemeProvider>
                    )}
                  </Stack>

                  <Stack direction='column' alignItems='center' justifyContent='center'>
                    <div>
                      <Button
                        onClick={clientFilingRollOverPa}
                        disabled={!statusPa.clientBtn}
                        sx={{
                          backgroundColor: primaryColor,
                          color: tokens.colors.white,
                          borderRadius: "50px",
                          textTransform: "none",
                          padding: "10px 24px",
                          "&:hover": { backgroundColor: primaryColor },
                          "&:disabled": { backgroundColor: "#e0e0e0", color: "#9e9e9e" }
                        }}
                      >
                        {statusPa.clientBtnTitle}
                      </Button>
                    </div>
                    {statusPa.clientBtn && (
                      <ThemeProvider theme={theme}>
                        <Typography variant='subtitle1' sx={{ color: 'white' }}>
                          {" "}
                          Rollover year:{statusPa.rollOverYear}
                        </Typography>
                      </ThemeProvider>
                    )}
                  </Stack>
                </Stack>
              </Stack>
            )}

            {(isAdmin || isAdminPostaward) && (
              <Stack direction='row' justifyContent='space-evenly'>
                <div>
                  <Button
                    onClick={completeRollOver}
                    disabled={!status.completeBtn || !statusPa.completeBtn}
                    sx={{
                      backgroundColor: primaryColor,
                      color: tokens.colors.white,
                      borderRadius: "50px",
                      textTransform: "none",
                      padding: "10px 24px",
                      "&:hover": { backgroundColor: primaryColor },
                      "&:disabled": { backgroundColor: "#e0e0e0", color: "#9e9e9e" }
                    }}
                  >
                    Complete Rollover
                  </Button>
                  {!status.completeBtn ||
                    (!statusPa.completeBtn && (
                      <ThemeProvider theme={theme}>
                        <Typography variant='subtitle1' sx={{ color: 'white' }}>
                          {" "}
                          Rollover year:{status.rollOverYear}
                        </Typography>
                      </ThemeProvider>
                    ))}
                </div>
              </Stack>
            )}

            {isLoading ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "20vh",
                }}
              >
                <CircularProgress />
              </div>
            ) : null}
          </Stack>
        </Grid>
        <Grid item xs={0.7} sx={{
          position: "sticky",
          top: 10,
          alignSelf: "flex-start",
        }}>
          <Box
            sx={{
              height: "100%",
              background: "transparent",
              marginTop: "0",
            }}
          >
            <Item sx={{ height: "100%", background: "transparent", boxShadow: "none", borderRadius: "50px", overflow: "visible" }}>
              <RollOverFilingsToolBox displayHistory={displayHistory} />
            </Item>
          </Box>
        </Grid>
      </Grid>
      <RollOverFilingsHistory
        show={showHistory}
        dockAt="right"
        activityHistory={activityHistory}
        handleClose={closeHistory}
      />
    </Fragment>
  );
}

